import React, { Component }     from 'react';

class RecentListItem extends Component {
    constructor(props) {
        super(props);

        this.toggleDeleteOn = this.toggleDeleteOn.bind(this);
        this.toggleDeleteOff = this.toggleDeleteOff.bind(this);

        this.state = {
            showDelete: false
        }
    };

    toggleDeleteOn(e) {
        this.setState({
            showDelete: true
        })
    }

    toggleDeleteOff(e) {
        this.setState({
            showDelete: false
        })
    }

    render() {
        return (
            <p className="recent-document" onMouseEnter={this.toggleDeleteOn} onMouseLeave={this.toggleDeleteOff}>
                <button className="link-button" onClick={this.props.update.bind(null, this.props.doc)}>
                    <span className="fa fa-angle-double-left recent-bullet"></span>
                    { this.props.doc.preview }
                </button>

                {this.state.showDelete ? <span className="fa fa-times recent-delete" 
                    onClick={this.props.delete.bind(null, this.props.doc)}></span> 
                : null}
            </p>
        )
    }
}

class RecentList extends Component {
    constructor(props) {
        super(props);

        this.clearSaves = this.clearSaves.bind(this);
    };

    clearSaves(e) {
        e.preventDefault();
        localStorage.clear();
        localStorage.setItem('recentDocuments', JSON.stringify([]));
        this.props.clearList();
    };

    render() {
        return (
            <div>
                <h2 className="heading-4">Recently Viewed Documents</h2>
                <p className='no-history' hidden={this.props.list.length !== 0}>No Previous Searches</p>

                <div>
                {
                    this.props.list.map(function(recentDoc, id) {
                        return(
                            <RecentListItem key={recentDoc.text}
                                doc={recentDoc} 
                                update={this.props.update} 
                                delete={this.props.deleteItem}/>
                        );
                    }, this)
                }
                </div>

                <button className="clear-history" onClick={this.clearSaves} hidden={this.props.list.length === 0}>
                    <span className="fa fa-times"></span>
                    Clear Recent Documents
                </button>
            </div>
        )
    }
}

export default RecentList;

